import { Link } from "react-router-dom";

const variants = {
  primary: "bg-brand-orange text-white shadow-glow hover:-translate-y-0.5 hover:bg-orange-600 focus-visible:outline-brand-orange",
  secondary: "bg-brand-blue text-white shadow-brand hover:-translate-y-0.5 hover:bg-blue-600 focus-visible:outline-brand-blue",
  ghost: "border border-slate-300 bg-white/80 text-slate-800 hover:border-brand-blue hover:text-brand-blue focus-visible:outline-brand-blue dark:border-slate-600 dark:bg-slate-800/80 dark:text-slate-200 dark:hover:border-brand-blue dark:hover:text-brand-blue",
};

const Button = ({ title, href, variant = "primary", className = "", type = "normal", disabled = false, onClick = null }) => {
  return (<>
      {
        type === "normal" ? (
          <Link
            to={href}
            target="_blank"
            className={`inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm md:text-base font-semibold tracking-wide transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${variants[variant]} ${className}`}
          >
            {title}
          </Link>
        ) : type === "submit" ? (
          <button
            type="submit"
            disabled={disabled}
            className={`inline-flex h-11 items-center justify-center rounded-xl px-5 text-base font-semibold tracking-wide transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none ${variants[variant]} ${className}`}
          >
            {title}
          </button>
        ) : (
          <button
            type="button" onClick={onClick} disabled={disabled}
            className={`inline-flex h-11 items-center justify-center rounded-xl px-5 text-base font-semibold tracking-wide transition duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none ${variants[variant]} ${className}`}
          >
            {title}
          </button>
        )
      }
   
      </>);
};

export default Button;